import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import { useSelector } from "react-redux";
const Equipments = (props) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.login);
  console.log(user);
  const [attributes] = useState([
    {
      type: "select",
      placeholder: "Issued by",
      name: "issuedBy",
      validation: "",
      showItem: "fullName",
      default: "",
      label: "Issued by",
      required: true,
      view: true,
      add: false,
      update: true,
      filter: false,
    },
    {
      type: "select",
      placeholder: "Employee",
      name: "user",
      validation: "",
      showItem: "fullName",
      default: "",
      label: "Employee",
      required: true,
      view: true,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "user/select", // Assume this is the API endpoint to fill the list
    },
    {
      type: "select",
      placeholder: "Type",
      name: "equipmentType",
      validation: "",
      showItem: "locale",
      default: "",
      label: "Type",
      required: true,
      view: true,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "equipment-type/select", // Assume this is the API endpoint to fill the list
    },
    {
      type: "datetime",
      placeholder: "Handed over on",
      name: "handedOverOn",
      validation: "",
      showItem: "",
      default: "",
      label: "Handed over on",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "datetime",
      placeholder: "Returned on",
      name: "returnedOn",
      validation: "datetime",
      default: "empty",
      label: "Returned on",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "Product name",
      name: "productName",
      validation: "",
      showItem: "",
      default: "",
      label: "Product name",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "Serial number",
      name: "serialNumber",
      validation: "",
      showItem: "",
      default: "",
      label: "Serial number",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "Status",
      name: "status",
      validation: "",
      showItem: "",
      default: "",
      label: "Status",
      required: true,
      view: true,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi: [
        { id: "active", value: t("active") },
        { id: "inactive", value: t("inactive") },
      ],
    },
    {
      type: "text",
      placeholder: "Inventory number",
      name: "inventoryNumber",
      validation: "",
      showItem: "",
      default: "",
      label: "Inventory number",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "note",
      name: "notes",
      validation: "",
      showItem: "",
      default: "",
      label: "note",
      required: false,
      view: true,
      add: true,
      update: true,
    },
  ]);
  //to update the page title
  useEffect(() => {
    document.title = `${t("equipments")} - PersoBase`;
  }, [t]);
  // const [actions] = useState([{ element: "button", icon: "timings", type: "subList", id: "shift-timing", itemTitle: "title", title: "timings", attributes: timingAttributes, params: { api: `timing`, itemTitle: "title", shortName: "Timing", addPrivilege: true, delPrivilege: true, updatePrivilege: true, customClass: "medium" } }]);
  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      <ListTable dragList={true} {...props} api={`equipments`} itemTitle={`title`} shortName={`equipments`} addPrivilege={true} delPrivilege={true} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Equipments);
